
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import RepeaterItemTitleText from "@/components/Reusable/CustomInputs/Repeater/RepeaterItemTitleText.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    Icon,
    RepeaterItemTitleText
  }
})
export default class RepeaterItemAccordion extends Vue {
  @Prop({ default: true })
  canDrag!: boolean;

  @Prop({ default: false })
  canEdit!: boolean;

  @Prop({ default: false })
  noDuplicate!: boolean;

  @Prop({ default: false })
  expanded!: boolean;
}
